@let isExperianCompany = isExperianCompany$ | async;

<div class="grid gap-4 justify-items-center">
  <div class="grid gap-2 justify-items-center">
    @if (!isExperianCompany) {
      <div class="text-28 bold-800">{{ adviserInfo.name }}</div>
    }
    <div class="logo-wrapper">
      @if (adviserInfo.companyLogo) {
        <img [ngSrc]="adviserInfo.companyLogo" alt="Company logo" [fill]="true" />
      }
    </div>
  </div>
  @if (showContactCTAs && !isExperianCompany) {
    <div class="grid gap-2 w-100">
      <span class="text-10 bold text-center uppercase">Contact your adviser</span>
      <div class="layout-fr-fr gap-2">
        <a [href]="'tel:' + adviserInfo.phoneNumber">
          <button pButton class="p-button p-button-primary centered w-100">
            <shared-icon class="fill-light" icon="phone" height="1.5rem" width="1.5rem" />
          </button>
        </a>
        <a [href]="'mailto:' + adviserInfo.email">
          <button pButton class="p-button p-button-primary centered w-100">
            <shared-icon class="fill-light" icon="mail" height="1.5rem" width="1.5rem" />
          </button>
        </a>
      </div>
    </div>
  }
</div>
